import ApiService from "./apiService";
import {
  PaymentConfigurationResponse,
  AuthorizationUrlResponse,
  LinkPaymentRequest,
} from "../types/payment.type";

const endpoint = "/api/v1/negocios/payments";

class PaymentsService extends ApiService {
  getConfiguration() {
    return this.get<PaymentConfigurationResponse>(`${endpoint}/configuration`, {
      auth: true,
      negocioActivo: true,
    });
  }

  getAuthorizationUrl() {
    return this.get<AuthorizationUrlResponse>(`${endpoint}/authorization-url`, {
      auth: true,
      negocioActivo: true,
    });
  }

  linkPayment(data: LinkPaymentRequest) {
    return this.post(`${endpoint}/link`, data, {
      auth: true,
      negocioActivo: true,
    });
  }

  unlinkPayment() {
    return this.post(
      `${endpoint}/unlink`,
      {},
      {
        auth: true,
        negocioActivo: true,
      }
    );
  }
}

const paymentsService = new PaymentsService();
export default paymentsService;
